import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleApiResponse } from 'utilities/apiUtils';

export function useCertificateSummary(insuredDatabaseId: string) {
  const [summary, setSummary] = useState<{
    total: number;
    active: number;
    pending: number;
  } | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!insuredDatabaseId) return;
    setLoading(true);
    setError(null);
    const NCToken = localStorage.getItem('NCToken');
    const igtoken = localStorage.getItem('igtoken');
    if (!NCToken || !igtoken) {
      setError('Missing tokens');
      setLoading(false);
      return;
    }
    fetch(`${process.env.REACT_APP_COIPortal_Url}/api/IGIGCOI/sent-certificate-summary?insuredDatabaseId=${insuredDatabaseId}`,
      {
        headers: {
          'NCToken': NCToken,
          'Authorization': `Bearer ${igtoken}`,
          'Accept': 'application/json',
        },
      })
      .then(res => handleApiResponse(res, navigate))
      .then(res => res.json())
      .then((data) => {
        setSummary({
          total: data.total ?? 0,
          active: data.active ?? 0,
          pending: data.pending ?? 0,
        });
      })
      .catch(e => {
        if (e.message === 'Unauthorized') return;
        setError(e.message || 'Failed to load summary');
      })
      .finally(() => setLoading(false));
  }, [insuredDatabaseId]);

  return { summary, loading, error };
}
